module.exports = __webpack_public_path__ + "static/img/NSW-35.606a007.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NSW-35.jpg
// module id = xA5j
// module chunks = 0